import { brandBeta, brandMark } from '@lunary/ui-tokens'
import { BrandBetaBadge } from './brand-beta-badge'
import { isBrandBeta } from './brand-stage'
import styles from './brand-loader.module.css'

type Props = { size?: number; label?: string; caption?: string; beta?: boolean }

export function BrandLoader({ size = 64, label = 'Загрузка', caption, beta = isBrandBeta() }: Props) {
  return (
    <div className={styles.wrap} role="status" aria-label={label}>
      <svg className={styles.mark} width={size} height={size} viewBox="22 14 74 70" aria-hidden="true">
        <path className={styles.letter} d={brandMark.letter} />
        <path className={styles.moon} d={brandMark.moon} />
        <path className={`${styles.spark} ${styles.large}`} d={brandMark.sparkLarge} />
        <path className={`${styles.spark} ${styles.small}`} d={brandMark.sparkSmall} />
        {beta && <BrandBetaBadge {...brandBeta.mark} className={styles.badge} />}
      </svg>
      {caption && <p className={styles.caption}>{caption}</p>}
    </div>
  )
}
